import { createTheme } from "@mui/material/styles";

/**
 * Tranos brand theme — professional gold.
 * Primary: gold (#C9A227) | Warm neutral backgrounds.
 * Design system lite — spacing scale: 4, 8, 12, 16, 24, 32 (theme units 0.5, 1, 1.5, 2, 3, 4).
 */
export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#C9A227",
      light: "#E0C14A",
      dark: "#A68B20",
      contrastText: "#1a1a1a",
    },
    secondary: {
      main: "#1e3a5f",
      light: "#2d4a6f",
      dark: "#152a45",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F5F3F0",
      paper: "#FFFFFF",
    },
    error: { main: "#DC2626" },
    success: { main: "#059669" },
    warning: { main: "#D97706" },
    info: { main: "#1e3a5f" },
    text: {
      primary: "#1a1a1a",
      secondary: "#5c5c5c",
      disabled: "#9CA3AF",
    },
    divider: "rgba(0,0,0,0.08)",
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, letterSpacing: "-0.02em" },
    h5: { fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    body1: { lineHeight: 1.55 },
    body2: { lineHeight: 1.5 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
  },
  spacing: 8,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollBehavior: "smooth",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "8px 20px",
          textTransform: "none",
          fontWeight: 600,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
          },
        },
        sizeLarge: {
          padding: "10px 24px",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundImage: "none",
        },
        outlined: {
          borderColor: "rgba(0,0,0,0.08)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          "&.Mui-selected": {
            backgroundColor: "rgba(201, 162, 39, 0.12)",
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          maxWidth: "calc(100vw - 32px)",
        },
      },
    },
  },
});
